/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, MemberRole, MemberRoleOrGuest, OrganizationTeam } from "./data-contracts";

/**
 * No description
 * @tags collection-teams
 * @name ListTeamPermissionsInCollection
 * @summary List a collection team permissions
 * @request GET:/collections/{collectionId}/permissions/teams
 * @secure
 */

// @ts-ignore
export const listTeamPermissionsInCollection: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: {
      /**
       * "The role of a member in an organization.
       * "admin": Can administrate the content: create, delete spaces, ...
       * "create": Can create content.
       * "review": Can review content.
       * "edit": Can edit the content (live or change requests).
       * "comment": Can access the content and its discussions.
       * "read": Can access the content, but cannot update it in any way.
       */
      permission: MemberRole;
      team: OrganizationTeam;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/collections/{collectionId}/permissions/teams",
  method: "get",
  streaming: false,
  tags: ["collection-teams"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-teams
 * @name UpdateTeamPermissionInCollection
 * @summary Update a collection team permission
 * @request PATCH:/collections/{collectionId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const updateTeamPermissionInCollection: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
    /** The unique ID of the Team */
    teamId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The role of a member in an organization, null for guests */
    role?: MemberRoleOrGuest;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/collections/{collectionId}/permissions/teams/{teamId}",
  method: "patch",
  streaming: false,
  tags: ["collection-teams"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags collection-teams
 * @name RemoveTeamFromCollection
 * @summary Remove a team from a collection
 * @request DELETE:/collections/{collectionId}/permissions/teams/{teamId}
 * @secure
 */

// @ts-ignore
export const removeTeamFromCollection: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the collection */
    collectionId: string;
    /** The unique ID of the Team */
    teamId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/collections/{collectionId}/permissions/teams/{teamId}",
  method: "delete",
  streaming: false,
  tags: ["collection-teams"],
  criticalityLevel: "low",
  deprecated: false,
};
